import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'optionFilter',
  standalone: true,
})
export class OptionFilterPipe implements PipeTransform {
  transform(options: { label: string; value: any }[], ...args: unknown[]): any {
    const string = (<string>args[0]).toLowerCase().trim();
    return options.filter((option: any) => option.label.toLowerCase().includes(string));
  }
}
